@if (formGroup?.get('id_order')) {
<div id="tabcontainer" [class.locked]="locked" [formGroup]="formGroup">
	<div class="flexrow">
		<mat-button-toggle-group name="deliverymodegroup" aria-label="Modes de livraison" formControlName="mode"
			(change)="onChangeDeliveryMode($event)" [hideSingleSelectionIndicator]="true">
			@for (m of deliverymodes; track m.id) {
			<mat-button-toggle class="secondary" value="{{m.id}}" id="{{'deliverymodes_'+m.id}}">{{ m.name
				}}</mat-button-toggle>
			}
		</mat-button-toggle-group>

		@if (showDatedel()) {
		<div class="flexSubRow">
			<!-- Le sélecteur de date partagé, celui des devis et des tournées (app-select-date) :
			     flèches −1 / +1 jour, raccourci « Aujourd'hui », et surtout sa saisie clavier
			     tolérante (FrenchTypedDateAdapter : « 2 », « 2/8 », « 02/08/24 »).
			     Il n'est pas un ControlValueAccessor — il expose [date]/(dateChange) — d'où le
			     branchement explicite sur le contrôle du formulaire. `is_valid()` est rappelé
			     comme le font les autres contrôles de cette rangée ; le reste passe par
			     valueChanges, auquel le composant est déjà abonné.
			     NOTE : le [min]="mindate" de l'ancien champ disparaît avec lui — app-select-date
			     n'expose pas de borne. Le TODO qui l'accompagnait disait déjà qu'il était faux
			     pour les livraisons existantes (il interdisait de ressaisir une date passée). -->
			<app-select-date label="" [date]="formGroup.get('askdatdel')?.value"
				(dateChange)="formGroup.get('askdatdel')?.setValue($event); is_valid()"></app-select-date>

			<div> <!-- AM / PM -->
				<mat-button-toggle-group (change)="onChangeSlotDay($event)" [value]="getSlotDayValue()"
					[hideSingleSelectionIndicator]="true">
					@for (slot of slotsDay; track slot.id) {
					<mat-button-toggle class="secondary" value="{{ slot.id }}" id="{{'slot_'+slot.id}}">{{ slot.name
						}}</mat-button-toggle>
					}
				</mat-button-toggle-group>
			</div>
		</div>
		}

		<div class='spacer'></div>
		#{{ formGroup.get('id')?.value }}
	</div>
	@if( formGroup.get('mode')?.value ==='4' && formGroup.get('askdatdel')?.value && (formGroup.get('askslot')?.value
	??0) > 0){
	<div class="flexrowLeft">
		<mat-checkbox (change)="onChangePrecision($event, 1)" [formControl]="precisionControl1" id="checkboxprecision_1"
			class="secondary">Précision 1</mat-checkbox>
		@if(niveauPrecisionhoraire==1){
		<mat-button-toggle-group (change)="is_valid()" formControlName="askop" [hideSingleSelectionIndicator]="true">
			@for (slotsOperator of operatorsL1; track slotsOperator.id) {
			<mat-button-toggle class="secondary" value="{{ slotsOperator.id }}"
				id="{{'slotsOperator_'+slotsOperator.id}}">{{ slotsOperator.name }}</mat-button-toggle>
			}
		</mat-button-toggle-group>
		}
	</div>
	<div class="flexrowLeft">
		@if(niveauPrecisionhoraire>0){
		<mat-checkbox (change)="onChangePrecision($event, 2)" [formControl]="precisionControl2" id="checkboxprecision_2"
			class="secondary">Précision 2</mat-checkbox>
		}
		@if(niveauPrecisionhoraire>1){
		<mat-button-toggle-group (change)="is_valid()" formControlName="askop" [hideSingleSelectionIndicator]="true">
			@for (slotsOperator of operatorsL2; track slotsOperator.id) {
			<mat-button-toggle class="secondary" value="{{ slotsOperator.id }}"
				id="{{'slotsOperator_'+slotsOperator.id}}">{{ slotsOperator.name }}</mat-button-toggle>
			}
		</mat-button-toggle-group>
		<smart-select width="200px" formControlName="askslot" bindLabel="name" bindValue="id"
			[items]="askslotDayValue === '1' ? slotsMorning : slotsAfternoon"
			[compareWith]="compareSlotById" (selectionChange)="is_valid()"
			id="selectslothoraires">
		</smart-select>
		}
	</div>
	}

	@if(!locked){
		@if(errorMessage !==''){
		<div class="errorMsg">
			{{ errorMessage }}
		</div>
		} @else {
		<div class="validationMsg">Validation possible</div>
		}
	}
	@if (defaultMemoControl) {
	<div class="container-memo">
		<textarea class="memo" id="memo_delivrery" [formControl]="defaultMemoControl" (blur)="onMemoBlur()"></textarea>
	</div>
	}

	<!-- Temps sur place chez le client : détaché de la planification, prérempli par le paramètre par défaut -->
	<div class="duration-row">
		<label for="delivery_duration_input">Temps approximatif chez le client :</label>
		<mat-form-field class="duration-field">
			<input matInput type="number" min="0" max="999" [step]="durationStepMin" [value]="durationMin" inputmode="numeric"
				[disabled]="locked" (keydown)="onDurationKeydown($event)"
				(change)="onDurationMinChange($any($event.target).value)" id="delivery_duration_input" />
			<span matTextSuffix>min</span>
		</mat-form-field>
	</div>

	<!-- Les pièces jointes ne sont plus rendues ici : ce composant répond du QUAND et du
	     COMMENT de la livraison, pas des documents du bon. La page de programmation rend le
	     bouton « Ajoutez un fichier » sur sa ligne d'actions et la bande de vignettes sous la
	     carte, et appelle `onFileSelected` / lit `attachs_images` par sa référence #plan.
	     L'état, lui, reste ici : c'est ce composant qui tient `lnk_attachs`. -->
</div>
}
